/** True when MSW and mock auth are allowed (non-production + REACT_APP_API_MOCKS). */
export const isApiMocksEnabled =
  process.env.REACT_APP_API_MOCKS === 'true' && process.env.REACT_APP_STAGE !== 'production';
